import styled from 'styled-components'

export const StyledWrapper = styled.div`
    display: flex;
    flex-direction: row;
    border: 2px #FFCD05 solid;
    border-radius: 8px;
    padding: 16px;
    margin: 16px 0px;
    background: white;
    justify-content: space-between;
`

export const StyledTextWrapper = styled.div`
    display: flex;
    flex-direction: row;
`

export const StyledIconWrapper = styled.div`
    margin-right: 4px;
    height: 20px;
`

export const StyledText = styled.div`
    font-size: 14px;
    font-weight: 400;
    line-height: 165%;
    color: #3E3E47;
`

export const StyledCloseButton = styled.button`
  border: none;
  padding: 0;
  margin-left: 4px;
  background: transparent;
  height: 16px;
  width: 16px;
  cursor: pointer;
`
